import { Center, Checkbox, Divider, Input, Table } from "@mantine/core";
import type { FormArrayElement, UseFormReturnType } from "@mantine/form";
import type { ReactNode } from "react";
import { Role, roleTranslations } from "../../models/enums/role";

export type ViewConfigFormType = {
  document_readable: Role[];
};

type ViewConfigFormProps<T extends ViewConfigFormType> = {
  form: UseFormReturnType<T>;
  disabled?: boolean;
  roles?: Role[];
  title?: ReactNode;
};

export function ViewConfigForm<T extends ViewConfigFormType>({
  form,
  roles = [Role.APPRENTICE, Role.APPRENTICE_SUPERVISOR, Role.PARENT],
  disabled = false,
  title = "Einsehbar",
}: ViewConfigFormProps<T>) {
  const roleEntries = Object.values(Role)
    .filter((role) => roles.includes(role))
    .map((key) => (
      <Table.Tr key={key}>
        <Table.Th>{roleTranslations[key]}</Table.Th>
        <Table.Td>
          {/* biome-ignore lint/a11y/noLabelWithoutControl: mantine */}
          <label>
            <Center>
              <Checkbox
                checked={form.getValues().document_readable.includes(key)}
                onChange={(event) => {
                  if (event.currentTarget.checked) {
                    form.insertListItem("document_readable", key as FormArrayElement<T, "document_readable">);
                  } else {
                    form.removeListItem("document_readable", form.getValues().document_readable.indexOf(key));
                  }
                }}
                disabled={disabled || key === Role.APPRENTICE}
              />
            </Center>
          </label>
        </Table.Td>
      </Table.Tr>
    ));
  return (
    <>
      <Divider />
      <Input.Label>Berechtigungen</Input.Label>
      <Table variant="vertical" layout="fixed" withColumnBorders verticalSpacing="sm" withTableBorder>
        <Table.Thead>
          <Table.Tr>
            <Table.Th />
            <Table.Th ta="center">{title}</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{roleEntries}</Table.Tbody>
      </Table>
    </>
  );
}
